import * as React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import isEqual from 'react-fast-compare';
import SeeAllLink from '../SeeAllLink/SeeAllLink';
import styled from 'styled-components';
import SymbolRatings from '@liveauctioneers/caterwaul-components/lib/SymbolRatings/SymbolRatings';

type Props = {
    hideReviewCount?: boolean;
    onClick?: (event: any) => void;
    rating: number;
    reviewCount?: number;
    starSize?: string;
    starSpacing?: string;
    to?: string;
};

const RatingDisplaySmall = (props: Props) => {
    const { hideReviewCount, onClick = null, rating, reviewCount, starSize = '24px', starSpacing = '2px', to } = props;
    const messageId = reviewCount === 1 ? 'review.review_count_singular' : 'review.review_count';
    return rating >= 0 ? (
        <RatingContainer onClick={onClick} style={{ cursor: Boolean(onClick) ? 'pointer' : 'default' }}>
            <SymbolRatingsStyled rating={rating} symbolSize={starSize} symbolSpacing={starSpacing} />
            {!hideReviewCount && (
                <SeeAllLink
                    text={
                        <FormattedMessage id={messageId} values={{ count: <FormattedNumber value={reviewCount} /> }} />
                    }
                    url={to}
                />
            )}
        </RatingContainer>
    ) : (
        <div>
            <span>N/A</span>
        </div>
    );
};

export default React.memo<Props>(RatingDisplaySmall, isEqual);

const RatingContainer = styled.div`
    cursor: pointer;
    flex: 1 1 auto;
    display: flex;
    flex-flow: row wrap;
    flex-direction: row;
    align-items: center;

    @media (max-width: 767px) {
        flex-direction: row;
    }
`;

const SymbolRatingsStyled = styled(SymbolRatings)`
    margin-right: 8px;
    display: flex;
    position: relative;
`;
